import {useAuth} from '@/modules/auth/api'
import {reloadWindow} from '@cypro/ui/hooks/use-reload-window'

export function useUser() {
  const {auth} = useAuth()

  if (!auth?.user || !auth.session) {
    throw reloadWindow()
  }

  return {
    user: auth.user,
    authContext: {
      user: {
        id: auth.user.id,
        email: auth.user.email,
      },
    },
  }
}
